// plugins/domain-locale.js

export default ({ app }) => {
  if (process.server) {
    return
  }

  const hostname = window.location.hostname

  // Сначала проверяем сохранённый язык
  const savedLocale = localStorage.getItem('locale')

  if (savedLocale) {
    if (app.i18n.locale !== savedLocale) {
      app.i18n.setLocale(savedLocale)
    }

    return
  }

  // Если язык ещё не выбран — определяем по домену
  let locale = 'mn'

  if (hostname.endsWith('.ru') || hostname.endsWith('.xn--p1ai')) {
    locale = 'ru'
  }

  if (hostname.endsWith('.mn')) {
    locale = 'mn'
  }

  if (app.i18n.locale !== locale) {
    app.i18n.setLocale(locale)
  }

  // Сохраняем первоначально определённый язык
  localStorage.setItem('locale', locale)
}
